import { useEffect, useState } from 'react';

export const useCheckPWA = () => {
  const [isPWA, setIsPWA] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(display-mode: standalone)');

    function handleMediaChange(event: MediaQueryListEvent | MediaQueryList) {
      setIsPWA(event.matches);
    }

    // Initial check
    handleMediaChange(mediaQuery);

    // Listen for changes
    mediaQuery.addEventListener('change', handleMediaChange);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, []);

  return isPWA;
};
